<template>
  <section class="card_style">
    <!-- Skeleton -->
    <div class="row" v-if="loading && $route.params.id">
      <div class="col-12 my-3">
        <Skeleton width="20%" class="my-2" />
      </div>
      <div class="col-12 my-3" v-for="i in 2" :key="i">
        <Skeleton width="20%" class="my-2" />
        <Skeleton width="70%" height="2rem" class="my-2" />
      </div>
      <div class="col-12 my-3">
        <Skeleton width="10%" height="10rem" />
      </div>
    </div>

    <!-- Form -->
    <form @submit.prevent="addMainSection" v-else>
      <div class="main_aboutus">
        <h4>{{ $t("Add Aboutus") }}</h4>
      </div>
      <div class="row">
        <!-- Title Fields -->

        <div class="col-6" >
          <div class="form-group">
            <label for="title_ar">{{ $t(`title_ar`) }}</label>
            <input
              type="text"
              class="form-control"
              id="title_ar"
              v-model="title_ar"
            />
          </div>
        </div>
        <div class="col-6" >
          <div class="form-group">
            <label for="title_en">{{ $t(`title_en`) }}</label>
            <input
              type="text"
              class="form-control"
              id="title_en"
              v-model="title_en"
            />
          </div>
        </div>

         <!-- SubTitle Fields -->
        <div class="col-6" >
          <div class="form-group">
            <label for="subtitle_ar">{{ $t(`subtitle_ar`) }}</label>
            <input
              type="text"
              class="form-control"
              id="subtitle_ar"
              v-model="subtitle_ar"
            />
          </div>
        </div>
        <div class="col-6" >
          <div class="form-group">
            <label for="subtitle_en">{{ $t(`subtitle_en`) }}</label>
            <input
              type="text"
              class="form-control"
              id="subtitle_en"
              v-model="subtitle_en"
            />
          </div>
        </div>

        <!-- Description Fields -->
        <div class="col-6">
          <div class="form-group">
            <label for="description_ar">{{ $t(`description_ar`) }}</label>
            <input
              type="text"
              class="form-control"
              id="description_ar"
              v-model="description_ar"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="description_en">{{ $t(`description_en`) }}</label>
            <input
              type="text"
              class="form-control"
              id="description_en"
              v-model="description_en"
            />
          </div>
        </div>

        <!-- Main Images -->
       <div class="col-12">
            <label class="form-label">{{ $t("video") }}</label>
            <input
                type="file"
                class="form-control"
                accept="video/*"
                multiple
                @change="onFileChange"
            />
            <div class="main-video-container">
                <div
                v-for="(video, index) in videoPreviews"
                :key="'main-video-' + index"
                class="video-container"
                >
                <video
                    class="entry_video"
                    :src="video"
                    controls
                    width="100%"
                ></video>
                <input
                    class="form-control"
                    :id="`alt-${index}`"
                    type="text"
                    v-model="video_alt[index]"
                    placeholder="Alt text or description"
                />
                </div>
            </div>
            </div>

       
        <!-- Submit -->
        <div class="col-12 mt-3">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import Skeleton from "primevue/skeleton";

export default {
  data() {
    return {
      v$: useVuelidate(),
      loading: false,
      title_en: "",
      title_ar: "",
      subtitle_ar: "",
      subtitle_en: "",
      description_en: "",
      description_ar: "",
      fileData: [],
      imagePreviews: "",
      image_alt: [],
  
    };
  },
  validations() {
    return {
      form: {
        title_en: { required },
        title_ar: { required },
        description_en: { required },
        description_ar: { required },
      },
    };
  },
  methods: {
    onFileChange(e) {
      const files = Array.from(e.target.files);
      this.fileData = [];
      this.imagePreviews = [];
      files.forEach((file) => {
        this.fileData.push(file);
        const reader = new FileReader();
        reader.onload = (e) => this.imagePreviews.push(e.target.result);
        reader.readAsDataURL(file);
      });
    },

  
    addMainSection() {
      const formData = new FormData();
      formData.append("title_ar", this.title_ar);
      formData.append("title_en", this.title_en);
      formData.append("subtitle_ar", this.subtitle_ar);
      formData.append("subtitle_en", this.subtitle_en);
      formData.append("description_ar", this.description_ar);
      formData.append("description_en", this.description_en);
      this.fileData.forEach((file) => {
        formData.append(`video`, file);
      });

      axios
        .post("/store_about_main", formData )
        .then(({ data }) => {
          Swal.fire({ icon: "success", text: data.message });
        //   this.$router.push("/aboutfeatures");
        })
        .catch((err) => {
          Swal.fire({ icon: "error", text: err.response?.data?.message || "Error occurred" });
        });
    },
  },
  components: {
    Skeleton,
  },
};
</script>

<style scoped>
.add-icon {
  margin: auto;
  background-color: #0f3450;
  width: fit-content;
  padding: 3px;
  border-radius: 5px;
  cursor: pointer;
}
.fa-plus:before {
  color: white;
}
.image-conteiner {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
}
.entry_image {
  width: 100px;
  height: auto;
  object-fit: cover;
}
</style>
